import { HandlerEvent } from 'post-robot';
import {
  getApp2AppPayload,
  getCardArtAndIssuerConfigs,
  getCvvConfig,
  getFidoConfig,
  getIssuerBaseData
} from 'communicator/store/selectors';
import { IssuerOTPRequestConfigs } from 'types/visa-sdk/authenticate';
import {
  IssuerData,
  BankAppConfig,
  CardArtConfig,
  CvvConfig,
  FidoConfig
} from 'types/visa-sdk/checkout';

export function getFidoConfigHandler(): FidoConfig {
  return getFidoConfig();
}

export async function getCvvConfigHandler(): Promise<CvvConfig> {
  return await getCvvConfig();
}

export async function getBankAppConfigHandler(
  event: HandlerEvent<IssuerData>
): Promise<BankAppConfig> {
  return await getApp2AppPayload(event.data.authenticationMethod);
}

export async function getCardAndIssuerConfigs(
  event: HandlerEvent<IssuerData>
): Promise<CardArtConfig> {
  return await getCardArtAndIssuerConfigs(event.data.authenticationMethod);
}

export async function getIssuerOtpConfigHandler(
  event: HandlerEvent<IssuerData>
): Promise<IssuerOTPRequestConfigs> {
  return await getIssuerBaseData(event.data.authenticationMethod);
}
